import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RoleModel } from 'Models'
import { FunctionAliasModel } from 'Pages/pp/matrixRole'

type MatrixRoleState = {
	one: RoleModel | null
	functions: FunctionAliasModel[]
}

const matrixRoleInitialState: MatrixRoleState = {
	one: null,
	functions: [],
}

export namespace MatrixRoleNS {
	export type GetOne = PayloadAction<number>
	export type SetOne = PayloadAction<RoleModel>
	export type ClearOne = PayloadAction
	export type UpdateOne = PayloadAction<{
		role_id: number
		function_ids: number[]
	}>
	export type getItems = PayloadAction
	export type setItems = PayloadAction<FunctionAliasModel[]>
	export type clearItems = PayloadAction
}

export const matrixRoleSlice = createSlice({
	name: 'role',
	initialState: matrixRoleInitialState,
	reducers: {
		getOne: (state, action: MatrixRoleNS.GetOne) => {},
		setOne: (state, action: MatrixRoleNS.SetOne) => {
			state.one = action.payload
		},
		clearOne: (state, action: MatrixRoleNS.ClearOne) => {
			state.one = null
		},
		updateOne: (state, action: MatrixRoleNS.UpdateOne) => {},

		getItems: (state, action: MatrixRoleNS.getItems) => {},
		setItems: (state, action: MatrixRoleNS.setItems) => {
			state.functions = action.payload
		},
		clearItems: (state, action: MatrixRoleNS.clearItems) => {
			state.functions = []
		},
	},
})
